namespace e5{
    export interface ImageLoaderOptions extends AbstractImageLoaderOptions {

    }

    class ImageLoader extends AbstractImageLoader<HTMLImageElement, ImageLoaderOptions>{
        protected defaultOptions(): CanvasLoaderOptions {
            return {
            };
        }
    }

    export interface LoaderOptionsMap {
        "image": ImageLoaderOptions;
    }
    
    export interface LoaderMap {
        "image": ImageLoader;
    }

    registerLoader("image", ImageLoader);
}